import React from 'react'
import { useTranslation } from 'react-i18next'

import { CustomButton, Icon, Loading, Modal } from 'src/components/ui'

import styles from './ContributionConfirmationModal.module.scss'

interface ContributionConfirmationModalProps {
  isActiveModal: boolean
  isActiveLoading: boolean
  setIsActiveModal: (value: boolean) => void
  handleClickWritingStars: () => void
}

const ContributionConfirmationModal = ({
  isActiveModal,
  isActiveLoading,
  setIsActiveModal,
  handleClickWritingStars,
}: ContributionConfirmationModalProps) => {
  const { t } = useTranslation()

  return (
    <>
      {isActiveModal && (
        <Modal className={styles.wrapper}>
          <Icon name='exclamationMark' />

          <p className={styles.title}>{t('attachment_to_bottle.conditional.depositing')}</p>
          <p className={styles.text}>{t('attachment_to_bottle.conditional.text')}</p>

          <div className={styles.tabs}>
            <CustomButton onClick={handleClickWritingStars} variant='contained' color='violet'>
              {t('attachment_to_bottle.conditional.reset_stars')}
            </CustomButton>
            <CustomButton onClick={() => setIsActiveModal(false)} variant='contained' color='orange' opacity>
              {t('attachment_to_bottle.conditional.cancel')}
            </CustomButton>
          </div>
        </Modal>
      )}

      {/* {isActiveLoading && <Loading />} */}
    </>
  )
}

export default ContributionConfirmationModal
